<template>
  <md-card-actions v-show="total > 0" >
    <pagination :total="total" v-model="page_no" :per-page="pageSize" class="pagination-no-border right-button" type= "info"/>
    <div style="width: 100px;">
      <el-select v-model="page_size" class="border-input page-select">
        <el-option :value="10">10/page</el-option>
        <el-option :value="20">20/page</el-option>
        <el-option :value="50">50/page</el-option>
        <el-option :value="100">100/page</el-option>
      </el-select>
    </div>
    <div class="total-page">
      <p >
        {{$I18n("go_to" )}} : <input class="card-category" type="input" @blur="go_to_page" v-model="go_to_value"/>
      </p>
    </div>
  </md-card-actions>
</template>
<script>
import { Pagination } from "@/components";
export default {
  name: "table-page-v2",
  components:{
    Pagination,
  },
  props: {
    total : {
      type: Number,
      default: 0,
    },
    pageSize : {
      type: Number,
      default: 10,
    },
    value : {
      type: Number,
      default: 1,
    },
  },
  data(){
    return {
      go_to_value: this.value,
      page_size: this.pageSize,
      page_no : this.value,
    }
  },
  watch:{
    pageSize(newValue){
      this.page_size = newValue
    },
    page_size(newValue){
      this.$emit('changePage', newValue)
    },
    page_no(newValue){
      this.$emit('input',newValue)
    },
    value(newValue, oldValue){
      if(this.page_no !== newValue && newValue !== oldValue){
        this.page_no = newValue
      }
    },
  },
  methods:{
    go_to_page(){
      let page = parseInt(this.go_to_value);
      let maxPage = Math.ceil(this.total / this.pageSize);
      if(isNaN(page) || page < 1){
        page = 1;
      }
      this.go_to_value = Math.min(page, maxPage);
      this.page_no = Math.min(page, maxPage);
    },
  },
};
</script>
<style type="text/css" scoped>
  .card-category{
    margin-top: 14px !important;
  }
  .card-category{
    width: 40px;
    border-radius: 2px;
    border: 1px #D9D9D9 solid;
    background: #FFFFFF;
    margin: 0 4px;
    color: #000;
    line-height: 30px;
    height: 32px;
    padding: 0 8px;
    margin-top: 0 !important;
  }
  .total-page p{
    margin: auto 5px;
  }
  /* 翻页 */
  /deep/ .el-input__inner{
    height: 30px;
    padding-left: 10px !important;
    line-height: 30px;
  }
  /deep/ .el-input__icon{
    line-height: 30px !important;
  }
  /*el-input--suffix*/
  /deep/ .page-select.border-input{
    height: 32px !important;
    border: 0.5px solid #D9D9D9 !important;
  }
  /deep/ .page-select.border-input.md-field input, .page-select.border-input.md-field select{
    height: 30px !important;
    line-height: 30px !important;
  }
</style>